export const globalLinkMap = new Map<string, string>();

export function populateLinkMap(links: Array<{ uuid: string; url: string }>) {
  links.forEach((link) => {
    globalLinkMap.set(link.uuid, link.url);
  });
}
